import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import StandardModalLayout from '../../Shared/UI/StandardModalLayout/components/StandardModalLayout';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import Button from '../../Shared/UI/Button/components/Button';
import Stack from '../../Shared/UI/Stack/components/Stack';
import { useUserMatchScoresState, useUserMatchScoresActions } from './UserMatchScoresContext';
import { createJobProspectFromMatchScore } from './restApi';

const CreateJobProspectModal = () => {
  const state = useUserMatchScoresState();
  const { closeCreateProspectModal, onResponse, onError } = useUserMatchScoresActions();
  const score = state?.createProspectScore;

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleConfirm = () => {
    createJobProspectFromMatchScore({
      body: {
        authenticity_token: authenticityToken,
        user_id: state?.userId,
        job_description_id: score.jobDescriptionId,
        job_description_type: score.jobDescriptionType,
        page_number: state?.pageNumber,
        sort_by: state?.sortBy,
        sort_direction: state?.sortDirection,
        gap_filter: state?.gapFilter,
      },
      onResponse,
      onError,
    });
  };

  return (
    <StandardModal
      isOpen={state?.createProspectModalIsOpen}
      contentLabel="Create Job Prospect"
      onRequestClose={closeCreateProspectModal}
    >
      <StandardModalLayout
        header={<PageTitle text="Create Job Prospect" />}
        body={
          <Stack>
            <p>Create a job prospect for this match score? The prospect will be created in <strong>Awaiting Admin Approval</strong> status.</p>
            {score && (
              <table>
                <tbody>
                  <tr><td><strong>Title</strong></td><td>{score.title || '—'}</td></tr>
                  <tr><td><strong>Company</strong></td><td>{score.companyName || '—'}</td></tr>
                  <tr><td><strong>Score</strong></td><td>{score.matchScore}</td></tr>
                </tbody>
              </table>
            )}
            {score?.blocked && (
              <>
                <p>Automatic prospect creation skipped this pair because a required qualification was unmet. Creating a prospect is the admin override.</p>
                {(score.unmetRequired || []).map((item, index) => {
                  const fullText = item?.text == null ? '' : String(item.text);
                  const displayText = fullText.length > 80 ? fullText.slice(0, 80) : fullText;
                  return (
                    <p key={index} title={fullText}>
                      {`Missing required: ${displayText}`}
                    </p>
                  );
                })}
              </>
            )}
          </Stack>
        }
        footer={
          <Stack direction="horizontal">
            <Button size="sm" onClick={handleConfirm}>Create Prospect</Button>
            <Button size="sm" variant="secondary" onClick={closeCreateProspectModal}>Cancel</Button>
          </Stack>
        }
      />
    </StandardModal>
  );
};

export default CreateJobProspectModal;
